/**
 * Preview Options Domain Type
 *
 * Preview effect toggle states for moderator well-being controls.
 * Used to apply visual safeguards (blur, grayscale, flip) to moderation
 * queue content during review sessions.
 *
 * Defined in core/domain because the core userPreferencesStorage service
 * depends on it — keeping it here avoids a reverse core→domain import.
 *
 * @module PreviewOptions
 */

/** Preview effect toggle states for moderator well-being controls */
export interface PreviewOptions {
  /** Blur effect on text and images */
  blur: boolean;
  /** Grayscale effect on images only */
  gray: boolean;
  /** Horizontal flip effect on images only */
  flip: boolean;
}

/** Default preview options — all effects OFF */
export const DEFAULT_PREVIEW_OPTIONS: PreviewOptions = {
  blur: false,
  gray: false,
  flip: false,
};
